import React from 'react';
type Bonus = {
  number: string;
  title: string;
  value: string;
  description: string;
  image: string;
  alt: string;
};
export const BonusStack = () => {
  const bonuses: Bonus[] = [{
    number: '1',
    title: 'Hormones in the Kitchen: 30 Complete Recipes',
    value: 'Real Value: $27',
    description: 'The 30 complete recipes designed to support each phase of your cycle. With supermarket ingredients, step-by-step preparation and the science behind each dish. Because what you eat is your most powerful medicine.',
    image: 'https://cdn.magicpatterns.com/uploads/uKc5KSk24JK85gw42GDamK/MOCKUT_BONUS_1_Hormones-in-the-Kitchen-30-Recipes-That-Work-With-Your-Body.png',
    alt: 'Hormones in the Kitchen — 30 Recipes ebook mockup'
  }, {
    number: '2',
    title: 'The Bible of Smart Supplementation',
    value: 'Real Value: $37',
    description: 'The 5 most science-backed supplements for female hormonal balance. No expensive brands, no confusion. Only what works, when to take it and why.',
    image: 'https://cdn.magicpatterns.com/uploads/8Wy4xEbUqrf3jXppB6omB4/MOCKUT_BONUS_2_The-Smart-Supplementation-Bible.png',
    alt: 'The Bible of Smart Supplementation ebook mockup'
  }, {
    number: '3',
    title: 'My Transformation Journal: Symptom and Progress Tracker',
    value: 'Real Value: $17',
    description: 'Your personalized workbook to track energy, sleep, cycle, digestion and mood. The measurement system that turns small changes into real evidence of progress.',
    image: 'https://cdn.magicpatterns.com/uploads/nWEPumsCxqdQZmujZuM5Ak/MOCKUT_BONUS_3_My-Transformation-Journal.png',
    alt: 'My Transformation Journal — Symptom & Progress Tracker mockup'
  }];
  return <section id="bonus-stack" className="w-full bg-light py-8 md:py-12 px-4 md:px-6 scroll-mt-16" data-id="element-12">
      <div className="max-w-[780px] mx-auto" data-id="element-13">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-14">
          Your 3 Exclusive Bonuses — Included Today
        </h2>

        <div className="flex flex-col w-full" data-id="element-15">
          {bonuses.map((bonus, index) => <div key={index} className="w-full bg-white border-[2px] border-accent border-l-[6px] border-l-medium rounded-[16px] p-6 md:p-8 shadow-[0_4px_16px_rgba(149,125,173,0.15)] mb-6 box-border overflow-visible flex flex-col md:flex-row md:items-center gap-6 md:gap-8" data-id="element-16">
              {/* Image */}
              <div className="w-full md:w-[40%] flex-shrink-0" data-id="element-17">
                <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-[12px] shadow-[0_8px_24px_rgba(149,125,173,0.2)] object-cover" data-id="element-18" />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 min-w-0" data-id="element-19">
                <div className="self-start bg-medium text-white font-lato font-bold text-[12px] tracking-[0.1em] py-[6px] px-[16px] rounded-[50px] inline-block mb-4" data-id="element-20">
                  BONUS {bonus.number}
                </div>

                <h3 className="font-playfair font-bold text-[22px] md:text-[26px] text-primary mb-2 leading-tight" data-id="element-21">
                  {bonus.title}
                </h3>

                <div className="self-start font-lato font-bold text-[13px] text-success bg-successBg py-[4px] px-[12px] rounded-[50px] inline-block mb-4" data-id="element-22">
                  {bonus.value}
                </div>

                <p className="font-lato text-[16px] text-secondary leading-[1.7] block visible m-0" style={{
              maxHeight: 'none',
              overflow: 'visible'
            }} data-id="element-23">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};